import { useMemo } from 'react';
import { parseLatitudeValue, parseLongitudeValue } from 'shared/utils';
import { useQueryParams } from '../useQueryParams/useQueryParams';

type LatLngQueryParams = {
  lat?: string | null;
  lng?: string | null;
};

type UseLatLngFromQueryParamsResult = {
  lat: number | undefined;
  lng: number | undefined;
};

export const useLatLngFromQueryParams = (): UseLatLngFromQueryParamsResult => {
  const [params] = useQueryParams<LatLngQueryParams>();

  return useMemo(
    () => ({
      lat: parseLatitudeValue(params.lat),
      lng: parseLongitudeValue(params.lng),
    }),
    [params.lat, params.lng],
  );
};
